var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftAtom3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 157,
    viewBox: "0 0 173 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1891 125.116L84.8876 67.5458L23.1007 73.0861",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6846 111.577C77.9339 107.642 87.1688 110.262 91.3097 117.434C95.4507 124.607 92.9267 133.61 85.6773 137.545C78.428 141.48 69.1931 138.859 65.0522 131.687C60.9112 124.515 63.4352 115.512 70.6846 111.577Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5634 112.67C81.1258 112.656 85.5925 115.032 88.0123 119.224",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2149 57.1848C24.788 52.5313 35.7086 55.6303 40.6053 64.1116C45.502 72.593 42.5176 83.2397 33.9445 87.8932C25.3714 92.5468 14.4509 89.4478 9.55416 80.9664C4.65745 72.4851 7.64188 61.8383 16.2149 57.1848Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4198 58.4201C28.7848 58.4097 34.0346 61.1879 36.8873 66.1289",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 14.7408C120.888 11.7638 127.875 13.746 131.008 19.1731C134.142 24.6002 132.232 31.4119 126.747 34.3889C121.263 37.3658 114.276 35.3837 111.142 29.9566C108.009 24.5295 109.919 17.7178 115.403 14.7408Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.52 15.6484C123.002 15.6406 126.424 17.4408 128.28 20.6545",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7827 50.851C82.3376 45.1217 95.782 48.9374 101.81 59.3785C107.838 69.8196 104.165 82.9271 93.6097 88.6564C83.0548 94.3856 69.6104 90.57 63.5822 80.1289C57.5541 69.6878 61.2279 56.5803 71.7827 50.851Z",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9819 52.3052C87.5538 52.2905 93.9909 55.708 97.4775 61.747",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftAtom3);
export default __webpack_public_path__ + "static/media/gift-atom-3.0ad51f8ecda55f5d62cee4658f4868a7.svg";
export { ForwardRef as ReactComponent };